module.exports = __webpack_public_path__ + "static/media/Line-1.c4babe2c.svg";